/* eslint-disable react/no-danger */
/* eslint-disable global-require */
import React from 'react';
import styles from './css/CondolenceItem.styl';
import _ from 'lodash';
import {Audio, IframedVideo, Video} from '../../../../shared/library';
import {formatDate} from '../../../../../appModules/utilities/formatHelpers';
import {handleAccessibleKeyDown} from '../../../../shared/utilities/componentHelpers';
import {CondolenceQuotesIcon, VideoPlayIcon} from '../../../../shared/Svgs';
import {AdControl} from 'legacy-advertising';
import {AD_PGB} from '../../../../shared/utilities/constants';
import {bindMethods} from '../../../../shared/utilities/componentHelpers';
import {sanitizeText} from '../../../../../appModules/utilities/formatHelpers';
import classNames from 'classnames';
import Likes from './Likes';

/**
 * Each condolence displayed in the guestbook
 * @param {Object} props The condolence item in the guestbook
 * @returns {JSX} CondolenceItem
 */
export default class CondolenceItem extends React.Component {
  static propTypes = {
    adService: React.PropTypes.object.isRequired,
    audioUrl: React.PropTypes.string,
    callbacks: React.PropTypes.object,
    city: React.PropTypes.string,
    condolenceId: React.PropTypes.number,
    date: React.PropTypes.string,
    firstName: React.PropTypes.string,
    handleClick: React.PropTypes.func,
    iconUrl: React.PropTypes.string,
    id: React.PropTypes.oneOfType([
      React.PropTypes.number,
      React.PropTypes.string,
    ]),
    isAd: React.PropTypes.bool,
    isModal: React.PropTypes.bool,
    isPhone: React.PropTypes.bool,
    lastName: React.PropTypes.string,
    likesCount: React.PropTypes.number,
    message: React.PropTypes.string,
    photo: React.PropTypes.shape({
      caption: React.PropTypes.string,
      url: React.PropTypes.string,
    }),
    primaryFuneralHome: React.PropTypes.object,
    relationship: React.PropTypes.string,
    sourceId: React.PropTypes.number,
    state: React.PropTypes.shape({
      code: React.PropTypes.string,
      name: React.PropTypes.string,
    }),
    video: React.PropTypes.shape({
      id: React.PropTypes.string,
      url: React.PropTypes.string,
    }),
    videoReadyCallback: React.PropTypes.func,
  };

  /**
   * CondolenceItem Item Constructor
   * @param  {Object} props The Passed in props
   * @return {Undefined} Returns nothing
   */
  constructor(props) {
    super(props);

    bindMethods(this, [
      'getMediaComponents',
      'getNameLabel',
      'getStyles',
      'handleClick',
      'handleLoadComplete',
    ]);
  }

  /**
   * Configure the condolence's message
   * @param {String} message the condolence's message
   * @param {Boolean} isModal If this hubItem is inside a modal
   * @param {Boolean} isPhone If the device is a phone
   * @returns {JSX} React Element
   */
  getMessage(message, isModal, isPhone) {
    if (!message) {
      return '';
    }

    const cleanMessage = sanitizeText(message, ['br']);
    let retMessage = cleanMessage;

    if (!isModal && !isPhone) {
      const CHAR_LIMIT = 500;

      if (cleanMessage && cleanMessage.length > CHAR_LIMIT) {
        retMessage = _.truncate(cleanMessage, {
          length: CHAR_LIMIT,
          separator: ' ',
        });
      }
    }

    return retMessage;
  }

  /**
   * Configure the condolence's location
   * @param    {string} city   The author's city
   * @param    {object} state  The author's full state name and state code
   * @returns  {string} Returns a formated location string
   */
  getLocation(city, state) {
    const {code, name} = state || {};

    return _.compact([city, code || name]).join(', ');
  }

  /**
   * Configure the items post information
   * @param   {string} date         The item date
   * @param   {string} location     The item location
   * @param   {string} relationship The item relationship
   * @returns {string} Returns the date, location, or relationship of the poster.
   */
  getCondolenceDetails(date, location, relationship) {
    return _.compact([date, location, relationship]).join(' | ');
  }

  /**
   * Returns proper image if one exists
   * @param  {String} photo    The photo object
   * @param  {String} iconUrl  The icon url
   * @param  {String} audioUrl The audio url
   * @param  {Object} video    The video object
   * @return {Object}          Media object
   */
  getImage(photo, iconUrl, audioUrl, video) {
    const photoUrl = _.get(photo, 'url');
    const audioImg = audioUrl ? require('./assets/audio@2x.png') : null;
    const videoImg = _.get(video, 'id')
      ? `https://cdn-thumbs.viddler.com/thumbnail_2_${video.id}_v1.jpg`
      : null;
    const tukiosImg = _.get(video, 'thumbnail', null);

    return {
      url: photoUrl || iconUrl || videoImg || tukiosImg || audioImg || false,
      isAudio: audioImg !== null,
      isCandle:
        !photoUrl && _.isString(iconUrl) && iconUrl.indexOf('/candle.jpg') > -1,
      isServiceVideo: _.get(video, 'type') === 'service_video',
      isTukios: tukiosImg !== null,
      isVideo: videoImg !== null,
    };
  }

  /**
   * Returns proper caption if one existss
   * @param  {Object} photo The photo object
   * @return {String} Caption string or null
   */
  getCaption(photo) {
    return _.get(photo, 'caption') ? sanitizeText(photo.caption, [
          'br',
        ]) : null;
  }

  /**
   * Constructs an Id
   * @param  {String} id An id string
   * @return {String}    The constructed id
   */
  getId(id) {
    return id ? `HubItem_${id}` : null;
  }

  /**
   * Returns the full name
   * @param  {String} firstName The first name
   * @param  {String} lastName  The last name
   * @return {String} The constructed full name
   */
  getFullName(firstName, lastName) {
    const displayFirstName = _.isNil(firstName) ? '' : firstName;
    const displayLastName = _.isNil(lastName) ? '' : lastName;

    return displayFirstName || displayLastName ? _.trim(sanitizeText(`${displayFirstName} ${displayLastName}`)) : null;
  }

  /**
   * returns correct class names
   * @param  {Boolean} isModal  is it a modal
   * @param  {Boolean} isCandle is it a candle
   * @param  {Boolean} isAd     is this an ad
   * @return {Object}           classnames style grouping
   */
  getCondolenceStyles(isModal, isCandle, isAd) {
    const conditionalClasses = {};

    conditionalClasses[styles.modal] = isModal;
    conditionalClasses[styles.candle] = isCandle;
    conditionalClasses[styles.isAd] = isAd;

    return classNames(styles.CondolenceItem, conditionalClasses);
  }

  /**
   * returns correct class names
   * @param  {Boolean} isVideo            is it a video
   * @param  {Boolean} isAudio            is it audio
   * @param  {Boolean} isCandle           is it a candle
   * @param  {Boolean} isCandleNoMessage  is this a candle with no message
   * @return {Object}           classnames style grouping
   */
  getFigureStyles(isVideo, isAudio, isCandle, isCandleNoMessage) {
    const conditionalClasses = {};

    conditionalClasses[styles.video] = isVideo;
    conditionalClasses[styles.audio] = isAudio;
    conditionalClasses[styles.candleFigure] = isCandle;
    conditionalClasses[styles.noMessage] = isCandleNoMessage;

    return classNames(conditionalClasses);
  }

  /**
   * returns figure to render
   * @param  {Number} id        the id required for Viddler video
   * @param  {Object} image     the image object
   * @param  {String} audioUrl  the audio url
   * @param  {Object} video     the video object
   * @param  {Function} videoReadyCallback callback for video ready
   * @param  {Boolean} isModal  is it a modal render
   * @param  {Object} itemStyles    styles
   * @return {Object}           array of components for render
   */
  getMediaComponents(
    id,
    image,
    audioUrl,
    video,
    videoReadyCallback,
    isModal,
    itemStyles
  ) {
    const components = [];
    let media = null;

    if (image.isServiceVideo) {
      media = (
        <IframedVideo
          aspect={524 / 512}
          isModal={isModal}
          key="media-figure"
          url={video.url}
          videoReadyCallback={videoReadyCallback}
        />
      );
    } else if (isModal) {
      if (image.isVideo) {
        media = (
          <Video
            id={id || 'HubItem'}
            key="media-figure"
            videoId={video.id}
            videoReadyCallback={videoReadyCallback}
          />
        );
      } else if (image.isTukios) {
        media = (
          <IframedVideo
            aspect={9 / 16}
            isModal={isModal}
            key="media-figure"
            url={video.url}
            videoReadyCallback={videoReadyCallback}
          />
        );
      } else if (image.isAudio) {
        media = <Audio key="media-figure" tabIndex="1000" url={audioUrl} />;
      } else {
        media = <img key="media-figure" src={image.url} />;
      }
    } else {
      media = <img key="media-figure" src={image.url} />;
    }

    components.push(media);
    if (!isModal && (image.isVideo || image.isAudio || image.isTukios)) {
      components.push(
        <span className={itemStyles.icon} key="play-icon">
          <VideoPlayIcon />
        </span>
      );
    }
    if (!isModal && image.isServiceVideo) {
      components.push(
        <span className={itemStyles.overlay} key="media-overlay" />
      );
    }
    return components;
  }

  /**
   * returns name identifying the condolence
   * @param  {String} sanitizedFullName the deceased name
   * @param  {Boolean} isTukios         is it a Tukios video
   * @param  {Boolean} isServiceVideo   is it a Service video
   * @return {String}  name label for the condolence
   */
  getNameLabel(sanitizedFullName, isTukios, isServiceVideo) {
    if (isTukios) {
      return `${sanitizedFullName} Tribute Video`;
    }
    if (isServiceVideo) {
      return `${sanitizedFullName} Service Video`;
    }
    return sanitizedFullName;
  }

  /**
   * click handler - stop prop provided click handler from being called on Likes click
   * @param  {event} e    click event
   * @return {Undefined}  returns nothing
   */
  handleClick(e) {
    if (
      _.get(e, 'target.attributes.id.value') !== 'likes' &&
      _.isFunction(this.props.handleClick)
    ) {
      this.props.handleClick();
    }
  }

  /**
   * load complete handler
   * @return {Undefined} returns nothing
   */
  handleLoadComplete() {
    const callbacks = _.get(this.props, 'callbacks.load', []);

    _.map(callbacks, func => {
      if (_.isFunction(func)) {
        func();
      }
    });
  }

  render() {
    const {
      audioUrl,
      city,
      condolenceId,
      date,
      handleClick,
      firstName,
      iconUrl,
      isAd,
      isModal,
      isPhone,
      lastName,
      likesCount,
      message,
      photo,
      primaryFuneralHome,
      relationship,
      sourceId,
      state,
      video,
      videoReadyCallback,
    } = this.props;
    const image = this.getImage(photo, iconUrl, audioUrl, video);
    const sanitizedCaption = this.getCaption(photo);
    const sanitizedMessage = this.getMessage(message, isModal, isPhone);
    const sanitizedFullName = this.getFullName(firstName, lastName);
    const condolenceDetails = this.getCondolenceDetails(
      formatDate(date, 'MM\\\\DD\\\\YYYY', 'MMMM DD, YYYY'),
      this.getLocation(city, state),
      image.isTukios ? _.get(primaryFuneralHome, 'name') : relationship
    );
    const hasMedia = _.some(image, Boolean);
    const id = this.getId(this.props.id);
    const handleOnKeyDown =
      isModal || _.isNull(handleClick)
        ? null
        : _.partial(handleAccessibleKeyDown, _, handleClick);
    const tabIndex = isModal ? null : '0';

    return isAd ? (
      <article
        className={this.getCondolenceStyles(isModal, image.isCandle, true)}
        id={id}
        onKeyDown={handleOnKeyDown}
        ref="container"
        tabIndex={tabIndex}
      >
        <div className={styles.content}>
          <AdControl
            adService={this.props.adService}
            adSize={AD_PGB.adSize}
            clientLoadOnly={AD_PGB.clientLoadOnly}
            maxIdleAdRefreshes={AD_PGB.maxIdleAdRefreshes}
            pageName={AD_PGB.pageName}
            positionId={AD_PGB.positionId}
            slotKeyValues={[{key: 'pid', value: sourceId.toString()}]}
            slotName={AD_PGB.slotName}
          />
        </div>
        <div className={styles.clear} />
      </article>
    ) : (
      <article
        className={this.getCondolenceStyles(isModal, image.isCandle, false)}
        id={id}
        onClick={this.handleClick}
        onKeyDown={handleOnKeyDown}
        onLoad={this.handleLoadComplete}
        ref="container"
        tabIndex={tabIndex}
      >
        {hasMedia ? (
          <figure
            className={this.getFigureStyles(
              image.isVideo,
              image.isAudio,
              image.isCandle,
              !sanitizedMessage && image.isCandle
            )}
          >
            <div className={styles.imageBackground} ref="figure">
              {this.getMediaComponents(
                id,
                image,
                audioUrl,
                video,
                videoReadyCallback,
                isModal,
                styles
              )}
            </div>
            {sanitizedCaption ? (
              <figcaption>
                <p dangerouslySetInnerHTML={{__html: sanitizedCaption}} />
              </figcaption>
            ) : null}
          </figure>
        ) : null}
        {sanitizedMessage ? (
          <div className={styles.body}>
            {hasMedia ? null : <CondolenceQuotesIcon />}
            <p dangerouslySetInnerHTML={{__html: sanitizedMessage}} />
          </div>
        ) : null}
        <div className={styles.postInfo}>
          {!sanitizedMessage && !hasMedia && (
            <p className={styles.rememberedBy}>Remembered By</p>
          )}
          <div className={styles.divider} />
          {sanitizedFullName ? (
            <p
              className={styles.name}
              dangerouslySetInnerHTML={{
                __html: this.getNameLabel(
                  sanitizedFullName,
                  image.isTukios,
                  image.isServiceVideo
                ),
              }}
            />
          ) : null}
          <p className={styles.details}>{condolenceDetails}</p>
        </div>
        <Likes
          condolenceId={condolenceId}
          likesCount={likesCount}
          sourceId={sourceId}
        />
      </article>
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/GuestBook/CondolenceItem.js